import { gql } from "@apollo/client";

const GET_TIPO_PROFESIONAL_USUARIO_LOGGEADO = gql`
query profesionalByIdUsuario{
    profesionalByIdUsuario{
        idTipoProfesionalNavigation{
            descripcion
        }
    }
}`;

export default GET_TIPO_PROFESIONAL_USUARIO_LOGGEADO;